export enum ForYouEventType {
    BANNER = "banner_find_for_you",
    REGION = "map_find_for_you",
    CRITERIA = "filters_find_for_you",
    USER = "generate_lead",
    ADDITIONAL = "additional_filters_find_for_you"
}
export enum ForYouEventType {
    BANNER = "banner_find_for_you",
    REGION = "map_find_for_you",
    CRITERIA = "filters_find_for_you",
    USER = "generate_lead",
    ADDITIONAL = "additional_filters_find_for_you"
}
